<template>
  <div>
    <mensajeSistema></mensajeSistema>
    <v-row>
      <!-- <v-col cols="12" class="d-flex justify-end" v-if="componenteEvento.agregar_submodulo">
        <ButtonComp @click="addItem(); evento = 'agregar';" textButton="Crear usuario" iconBut="fas fa-plus"
          normalButton />
      </v-col> -->
      <v-col cols="12">
        <ComundataTablecomp :headers="GestionUsuarioWMHeaders" :search="search" :items="Usuarios" whitSearch>

          <template v-slot:nombre_usuario="{ item }">
            <div>
              {{
                item.nombre_persona +
                " " +
                item.ape1_persona +
                " " +
                item.ape2_persona
              }}
            </div>
          </template>

          <template v-slot:estado_usuario="{ item }">

            <v-chip v-if="item.estado_usuario === 1" small class="color_activo">
              Activo
            </v-chip>

            <v-chip v-if="item.estado_usuario === 0" small class="color_inactivo">
              Inactivo
            </v-chip>
          </template>


          <template v-slot:action_editar="{ item }">
            <ButtonComp v-if="componenteEvento.editar_submodulo" @click="editItem(item); evento = 'editar';" editButton
              tooltipText="Editar usuario" />
          </template>

          <template v-slot:action_borrar="{ item }">
            <ButtonComp v-if="componenteEvento.borrar_submodulo" :disabled="(datoLogin.id == item.id)"
              @click="deleteConfirm(item)" deleteButton tooltipText="Eliminar usuario" />
          </template>

          <!-- <template v-slot:action_config="{ item }">
            <ButtonComp @click="configPermisos(item)" configButton tooltipText="Configurar permisos" />
          </template> -->

        </ComundataTablecomp>
      </v-col>
    </v-row>

    <v-form ref="formDatosValidar" lazy-validation>
      <ComunDialogCompVue v-model="dialogValidar" max-width="650" title="Verificar documento de identidad"
        @close-modal="dialogValidar = false">
        <template v-slot:body>
          <v-row>
            <v-col cols="12" sm="12" class="mt-2">
              <v-text-field v-model="documento_validar" label="Número de documento"
                :rules="[rul.required, rul.min4, rul.max12]" @keypress="restrictCharsNumeros($event)"></v-text-field>
            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <v-btn class="btn_block_style2" dark @click="validarDoc">
            <v-icon>mdi mdi-check</v-icon>
            Validar</v-btn>
          <v-btn class="btn_style3" dark @click="dialogValidar = false">Cancelar</v-btn>
        </template>
      </ComunDialogCompVue>
    </v-form>

    <v-form ref="formUsuarios" lazy-validation>
      <ComunDialogCompVue v-model="dialog" max-width="1500" :title="formTitle" @close-modal="dialog = false">
        <template v-slot:body>
          <v-row>
            <!--  Datos de personales -->
            <v-col cols="12" sm="12" md="12" class="pb-0">
              <v-alert dense border="left" class="text-center" color="#0277bd" dark>
                <h3>DATOS PERSONALES</h3>
              </v-alert>
            </v-col>
          </v-row>
          <v-row class="d-flex">
            <!-- {{this.datos}} -->
            <v-col cols="12" sm="12" md="9" class="py-0">
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                  <v-text-field v-model="datos.nombre_persona" label="Nombres" type="text"
                    :rules="[rul.required, rul.max50]" :readonly="bloquearInput"></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                  <v-text-field v-model="datos.ape1_persona" label="Apellido paterno" type="text"
                    :rules="[rul.required, rul.max40]" :readonly="bloquearInput"></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                  <v-text-field v-model="datos.ape2_persona" label="Apellido materno" type="text" :rules="[rul.max40]"
                    :readonly="bloquearInput"></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                  <v-select v-model="datos.id_tipo_documento" label="Tipo de documento" :items="TipoDocumentos"
                    item-value="id" item-text="desc_tipo_documento" :rules="[rul.selectReq]" :readonly="bloquearInput"
                    @change="changeDocument(datos.id_tipo_documento)">
                  </v-select>
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                  <v-text-field v-model="datos.numdoc_persona" label="Número de documento"
                    :rules="[rul.required, rul.maxDocument]" @keypress="restrictCharsNumeros($event)"
                    readonly></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                  <v-select v-model="datos.sexo_persona" :items="sexos" label="Sexo" item-text="nombre" item-value="abbr"
                    :rules="[rul.selectReq]" :readonly="bloquearInput">
                  </v-select>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" sm="12" md="3" class="d-flex justify-center order-first order-md-0" @click="pickAvatar">
              <v-avatar width="140" height="170" class="avatar_fondo_add_img">
                <v-icon color="grey lighten-2" class="fondo_add_img" size="130"
                  v-if="!avatarUsuario && !previewImgAvatar">fas fa-user-circle</v-icon>
                <!-- ?nocache=${new Date().getTime()} -->
                <v-img v-if="avatarUsuario && !previewImgAvatar" :src="avatarUsuario" dark contain class="fondo_add_img">
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>

                <v-img v-if="previewImgAvatar" :src="previewImgAvatar" contain aspect-ratio="1" class="fondo_add_img" />

                <input type="file" style="display: none" ref="imageAvatar" accept=".jpg, .png, .gif"
                  @change="onFileAvatar" />
              </v-avatar>
              <!-- <v-avatar size="116" hover @click="pickAvatar">

                  <v-icon
                    v-if="!avatarUsuario && !previewImgAvatar"
                    class="fondo_add_img"
                    dark
                    size="80"
                    >fas fa-user</v-icon
                  >
                  <img
                    v-if="avatarUsuario && !previewImgAvatar"
                    :src="avatarUsuario"
                    class="fondo_add_img"
                    dark
                    size="100"
                  />
                  <img
                    v-if="previewImgAvatar"
                    :src="previewImgAvatar"
                    class="fondo_add_img"
                    dark
                    size="100"
                  />

                  <input
                    type="file"
                    style="display: none"
                    ref="imageAvatar"
                    accept=".jpg, .png, .gif"
                    @change="onFileAvatar"
                  />
                </v-avatar> -->
            </v-col>

            <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
              <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="computedDateFormatted" label="Fecha de nacimiento" readonly v-on="on"
                    :rules="[rul.required]">
                  </v-text-field>
                </template>

                <v-date-picker v-model="datos.fecnac_persona" no-title @input="menu2 = false" :disabled="bloquearInput"
                  :max="getEndDate">
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
              <v-autocomplete v-model="datos.id_pais_nacimiento" :items="Paises" item-text="nombre_pais" item-value="id"
                :rules="[rul.selectReq]" label="País de nacimiento" :readonly="bloquearInput" @change="select_pais">
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
              <v-autocomplete v-model="datos.id_nacionalidad" :items="Nacionalidades" item-text="desc_nacionalidad"
                item-value="id" :rules="[rul.selectReq]" label="Nacionalidad" :readonly="bloquearInput">
              </v-autocomplete>
            </v-col>




            <v-col cols="12" sm="6" md="3" lg="3">
              <v-radio-group class="mt-0" v-model="datos.estado_usuario" label="Estado">
                <v-radio label="Activo" :value="1" color="teal"></v-radio>
                <v-radio label="Inactivo" :value="0" color="error"></v-radio>
              </v-radio-group>
            </v-col>

            <!--  fin de datos de personales -->

            <!--  Datos de usuarios -->
            <v-col cols="12" sm="12" md="12" class="pb-0">
              <v-alert dense border="left" class="text-center" color="#0277bd" dark>
                <h3>DATOS DE USUARIO</h3>
              </v-alert>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
              <v-text-field label="Nombre de usuario" type="text" v-model="datos.usu_usuario"
                :rules="[rul.required, rul.max40]" readonly></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="4" class="py-0" v-if="evento == 'agregar'">
              <v-text-field v-model="datos.password_usuario" :append-icon="show ? 'fa-eye' : 'fa-eye-slash'"
                :rules="[rul.required, rul.min6, rul.max20]" :type="show ? 'text' : 'password'" label="Contraseña"
                class="input-group--focused" @click:append="show = !show">
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="4" class="py-0" v-if="!habilitarUsMaster">
              <v-select v-model="datos.id_perfil" @change="cargarLicenciaTipo(datos.id_perfil)" :items="Perfil"
                item-text="descripcion_perfil" item-value="id" :rules="[rul.selectReq]" label="Perfil"
                :disabled="disableUserInputs">
              </v-select>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="4" class="py-0" v-if="!habilitarUsMaster">
              <v-select label="Tipo de licencia" v-model="datos.id_licencia_tipo" :items="LicenciaTipo"
                @change="cargarLicencia" item-value="id" item-text="desc_tipo_licencia"
                :readonly="datos.fecha_fin > new Date().toISOString().substr(0, 10)" :rules="[rul.selectReq]"
                :disabled="disableUserInputs">
              </v-select>
            </v-col>


            <v-col cols="12" sm="6" md="6" class="py-0" v-if="datos.fecha_fin > new Date().toISOString().substr(0, 10)
              ">
              Licencia
              <p class="black--text">{{ datos.serie_licencia }}</p>
            </v-col>

            <v-col cols="12" sm="6" md="6" class="py-0" v-else>
              <v-autocomplete label="Licencias" v-model="datos.id_licencia" :items="Licencia" item-value="id"
                item-text="serie_licencia" :rules="[rul.selectReq]" :disabled="disableUserInputs">
              </v-autocomplete>
            </v-col>


            <!--  fin  de usuarios -->

            <!--  Datos de ubicacion y contacto -->
            <v-col cols="12" sm="12" md="12" class="pb-0">
              <v-alert dense border="left" class="text-center" color="#0277bd" dark>
                <h3>DATOS DE UBICACIÓN Y CONTACTO</h3>
              </v-alert>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
              <v-autocomplete v-model="datos.id_ubicacion1" :items="Ubicacion1" :label="$t('ubicacion.ubicacion1')"
                item-text="nombre_ubicacion1" item-value="id" @change="loadUbicacion2(datos.id_ubicacion1)"
                :rules="[rul.selectReq]" :readonly="bloquearInput">
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
              <v-autocomplete v-model="datos.id_ubicacion2" :items="Ubicacion2" :label="$t('ubicacion.ubicacion2')"
                item-value="id" item-text="nombre_ubicacion2" @change="loadUbicacion3(datos.id_ubicacion2)"
                :rules="[rul.selectReq]" :readonly="bloquearInput">
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
              <v-autocomplete v-model="datos.id_ubicacion3" :items="Ubicacion3" :label="$t('ubicacion.ubicacion3')"
                item-text="nombre_ubicacion3" item-value="id" :rules="[rul.selectReq]" :readonly="bloquearInput">
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
              <v-text-field v-model="datos.telf_persona" label="Celular" type="number"
                @keypress="restrictCharsNumeros($event)" :rules="[rul.max12]" :readonly="bloquearInput">
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
              <v-text-field label="Correo electrónico" type="email" v-model="datos.correo_persona"
                :rules="[rul.email_null, rul.max50]" :readonly="bloquearInput"></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
              <v-text-field label="Dirección" v-model="datos.direc_persona" :rules="[rul.max150]"
                :readonly="bloquearInput"></v-text-field>
            </v-col>
            <!--  fin de ubicacion y contacto -->
          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>

          <v-btn class="btn_block_style2" dark v-if="evento == 'agregar'" @click="saveItem()">Guardar
          </v-btn>
          <v-btn class="btn_block_style2" dark v-if="evento == 'editar'" @click="saveItem()">
            Guardar Cambios
          </v-btn>
          <v-btn class="btn_style3" dark @click="dialog = false">Cancelar</v-btn>
        </template>
      </ComunDialogCompVue>
    </v-form>

    <ComunDialogCompVue v-model="dialog_delete" Deletedialog @close-modal="dialog_delete = false"
      :titleWindow="'Eliminar usuario'" @delete-item="deleteItem" @cancel-item="dialog_delete = false">
      <template v-slot:body>
        <h3>
          ¿Está seguro de eliminar este registro?
          <v-chip color="yellow font-weight-black">{{ desc_delete }}</v-chip>
        </h3>
      </template>
    </ComunDialogCompVue>

    <v-form ref="formPermisos" lazy-validation>
      <ComunDialogCompVue title="Configurar permisos de usuario" v-model="dialogPermisos" maxWidth="600"
        @close-modal="dialogPermisos = false">
        <template v-slot:body>
          <v-row>
            <v-col cols="12" class="d-flex justify-center">
              <v-chip small label class="mx-2">
                {{ variablesEntorno.perfildesc }}
              </v-chip>
              -
              <v-chip small label class="mx-2">
                {{ variablesEntorno.nameuser }}
              </v-chip>
            </v-col>
            <v-col cols="12">
              <v-card outlined>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12">
                      <v-row dense>
                        <v-col cols class="py-0">
                          <label class="font-weight-black black--text">
                            <h3></h3>
                          </label>
                        </v-col>

                        <v-col cols="1" class="btn_ver d-flex justify-center">
                          <v-tooltip bottom color="#1b1b1b">
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" dark x-small>fas fa-eye</v-icon>
                            </template>
                            <span>VISUALIZAR</span>
                          </v-tooltip>
                        </v-col>

                        <v-col cols="1" class="btn_otro d-flex justify-center">
                          <v-tooltip bottom color="#1b1b1b">
                            <template v-slot:activator="{ on }">
                              <div class="grid">
                                <v-icon dark x-small v-on="on">fas fa-plus</v-icon>
                              </div>
                            </template>
                            <span>AGREGAR</span>
                          </v-tooltip>
                        </v-col>

                        <v-col cols="1" class="btn_editar d-flex justify-center">
                          <v-tooltip bottom color="#1b1b1b">
                            <template v-slot:activator="{ on }">
                              <v-icon dark x-small v-on="on">fa-pencil-alt</v-icon>
                            </template>
                            <span>EDITAR</span>
                          </v-tooltip>
                        </v-col>

                        <v-col cols="1" class="btn_eliminar d-flex justify-center">
                          <v-tooltip bottom color="#1b1b1b">
                            <template v-slot:activator="{ on }">
                              <v-icon dark x-small v-on="on">fa-trash-alt</v-icon>
                            </template>
                            <span>ELIMINAR</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" v-for=" modulo  in  datosAgrupados " :key="modulo.id">
                      <v-row dense>
                        <v-col cols="12">
                          <v-divider />
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="12">
                          <span class="font-weight-bold primary--text">{{ modulo.nombre_modulo }}</span>
                        </v-col>
                      </v-row>
                      <v-row dense v-for="item in modulo.submodulos" :key="item.id_submodulo">
                        <v-col cols class="py-0">
                          <label class="black--text">{{ item.nombre_submodulo }}</label>
                        </v-col>

                        <v-col cols="1" class="pa-0 ma-0 d-flex justify-center">
                          <v-checkbox v-model="confSubModuloAll" :value="item.id"
                            @change="toggleTodosSeleccionados(item.id)"
                            :indeterminate="algunosPermisosSeleccionados(item.id)" class="my-0" color="#8E8E8E"
                            hide-details />
                        </v-col>

                        <v-col cols="1" class="px-0 py-0 d-flex justify-center">
                          <v-checkbox :disabled="validarPermisos(confSubModuloV, confSubModuloV_valida, item.id)"
                            v-model="confSubModuloV" :value="item.id" @change="seleccionarPermiso(item.id)" class="my-0"
                            color="#388e3c" hide-details />
                        </v-col>

                        <v-col cols="1" class="px-0 py-0 d-flex justify-center">
                          <v-checkbox :disabled="validarPermisos(confSubModuloA, confSubModuloA_valida, item.id)"
                            v-model="confSubModuloA" :value="item.id" @change="seleccionarPermiso(item.id)" class="my-0"
                            color="#01579b" hide-details />
                        </v-col>

                        <v-col cols="1" class="px-0 py-0 d-flex justify-center">
                          <v-checkbox :disabled="validarPermisos(confSubModuloE, confSubModuloE_valida, item.id)"
                            v-model="confSubModuloE" :value="item.id" @change="seleccionarPermiso(item.id)" class="my-0"
                            color="#ffbc00" hide-details />
                        </v-col>

                        <v-col cols="1" class="px-0 py-0 d-flex justify-center">
                          <v-checkbox :disabled="validarPermisos(confSubModuloD, confSubModuloD_valida, item.id)"
                            v-model="confSubModuloD" :value="item.id" @change="seleccionarPermiso(item.id)" class="my-0"
                            color="#e53935" hide-details />
                        </v-col>

                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- <v-col cols="12">
            <AutocompleteComp textLabel="Modulo" item-value="id" v-model="configuracion.id_modulo" :items="modulo"
              item-text="nombre_modulo" @change="onChangeSubModulo" :rules="validationRules.validateCampoList" />
          </v-col> -->

        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <ButtonComp @click="savePermisosUsuario" textButton="Guardar" iconBut="fas fa-save" normalButton />

          <ButtonComp normalButton classColor="red" @click="dialogPermisos = false" textButton="Cancelar"
            classButton="ml-2" />
        </template>



      </ComunDialogCompVue>


    </v-form>

  </div>
</template>



<script>
import axios, { BUCKET_ORIGIN_SPACE } from "@/helpers/axios" //API_URL
import { mapMutations, mapGetters, mapActions } from "vuex"
import ComunDialogCompVue from '../../components/ComponentsEst/ComunDialogComp.vue';
import moment from "moment"
import ComundataTablecomp from '../../components/ComponentsEst/ComundataTablecomp.vue';
// import AutocompleteComp from "../../components/ComponentsEst/AutocompleteComp.vue";
import ButtonComp from '../../components/ComponentsEst/TableButtonComp.vue';
import { GestionUsuarioWMHeaders } from '../../helpers/headersTable';
import { validationRules } from "../../helpers/validatorHelpers";

export default {
  components: {
    ComunDialogCompVue,
    ComundataTablecomp,
    ButtonComp,
    // AutocompleteComp
  },
  data: (vm) => ({
    paramComponente: { id_submodulo: 62, id_modulo: 5 },
    datoLogin: sessionStorage,
    configuracion: {},
    modulo: [],
    dialog_delete: false,
    desc_delete: null,
    id_delete: null,
    GestionUsuarioWMHeaders,
    Usuarios: [],
    Nacionalidades: [],
    search: "",
    variablesEntorno: {
      id: "",
      nameuser: "",
      perfildesc: "",
    },
    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo requerido",
      inputReq: (value) => !!value || "Campo requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo Electrónico es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max40: (v) => (v || "").length <= 40 || "Máximo 40 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",
      maxDocument: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "El correo Electrónico es incorrecto";
        }
      },
    },
    dialogValidar: false,
    dialogPermisos: false,
    bloquearInput: false,
    documento_validar: null,
    respuestaValidDoc: [],
    //-- funciones del date picker de fecha
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu2: false,
    // modal agregar editar usuario
    evento: null,
    dialog: false,
    formTitle: null,
    datos: {},

    //---------validacion password--
    show: false,
    //--------sexo------------------
    sexos: [
      { nombre: "Masculino", abbr: "M" },
      { nombre: "Femenino", abbr: "F" },
    ],

    habilitarUsMaster: false,
    Colegio: [],
    TipoDocumentos: [],
    Perfil: [],
    Licencia: [],
    Paises: [],
    LicenciaTipo: [],
    //-------Departamentos-----------
    Ubicacion1: [],
    //-------provincias--------------
    Ubicacion2: [],
    //-------Distritos--------------
    Ubicacion3: [],
    // Avatar  Persona imagen
    previewImgAvatar: "",
    imageSaveAvatar: "",
    URL_SPACE: BUCKET_ORIGIN_SPACE,

    confSubModulo: [],
    confSubModuloV: [],
    confSubModuloA: [],
    confSubModuloE: [],
    confSubModuloD: [],
    // VALIDACION DE ARRAY PERMISOS
    confSubModuloV_valida: [],
    confSubModuloA_valida: [],
    confSubModuloE_valida: [],
    confSubModuloD_valida: [],
    confSubModuloAll: [],
    confSubModuloAllIndeterminate: [],
    disableUserInputs: false,
    datosAgrupados: [],
  }),
  computed: {
    ...mapGetters({
      componenteEvento: 'login/componenteEvento',
    }),
    getEndDate() {
      return new Date().toISOString().substr(0, 10);
    },
    validationRules() {
      return validationRules
    },
    computedDateFormatted() {
      if (this.datos.fecnac_persona) {
        return moment(this.datos.fecnac_persona).utc().format('DD/MM/YYYY');
      }
      else {
        return null
        // Esto no es valido, los computed siempre deben retornar algo
      }
    },
    avatarUsuario() {
      //Trae la imagen que se le subio al momento de matricularlo (La imagen ya esta guardada en el SPACE)
      if (this.datos.ruta_avatar_persona) {
        const srcAvatar = `${this.URL_SPACE}/${this.datos.ruta_avatar_persona}`
        return srcAvatar
      } else {
        return null;
      }
    },
  },

  mounted() {
    setTimeout(() => {
      this.loadMain();
    }, 1000);
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    ...mapMutations({
      setEnviarMens: "mensajeSis/setEnviarMens",
    }),
    ...mapActions({
      parametroComponente: "login/parametroComponente",
    }),
    async actualizarParamentro() {
      await this.parametroComponente(this.paramComponente);
    },
    /**
     __________________________________________
    |          MÉTODO CARGA INICIAL          */
    async loadMain() {
      try {
        let response = await axios.get(
          "/sistema/usuario/getMain/" + this.datoLogin.id_colegio
        );

        //ESTO ES PARA OCULTAR EL USUARIO WEB MASTER DE INTELIGENIO 
        const allUsuarios = response.data
        this.Usuarios = allUsuarios.filter(usu => usu.master_colegio != 1)
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        console.log(error);
      }
    },
    /**
     ______________________________________________________
    |          MÉTODO AGRUPAR LISTA DE PERMISOS          */
    organizarDatos() {
      this.datosAgrupados = this.organizarPorModulo(this.confSubModulo);
    },
    /**
     ________________________________________________________________
    |          MÉTODO AGRUPAR LISTA DE PERMISOS POR MODULO         */
    organizarPorModulo(datos) {
      const datosAgrupados = {};

      datos.forEach((item) => {
        if (!datosAgrupados[item.id_modulo]) {
          datosAgrupados[item.id_modulo] = {
            nombre_modulo: item.nombre_modulo,
            submodulos: []
          };
        }

        datosAgrupados[item.id_modulo].submodulos.push(item);
      });

      return Object.values(datosAgrupados);
    },
    /**
     __________________________________________________________________
    |          MÉTODO CARGAR SUBMODULO DEL TIPO DE LICENCIA          */
    async getModuloTLicencia(id_colegio, id_licencia_tipo) {
      try {
        const response = await axios.get(
          `/sistema/perfilColegio/modulosTlicencia/${id_colegio}/${id_licencia_tipo}`
        );
        this.modulo = response.data;
        // console.log('Respueste de mmodulo', this.modulo);

      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
    /**
     ______________________________________________________________________
    |           MÉTODO OBTENER LOS PERMISOS SUBMODULOS PERFILES          */
    async cargarAllSubModuloPerf(id_modulo, id_perfil, id_licencia_tipo, id_colegio) {
      // if (this.configuracion.id_perfil != null) {
      let configuracionesPerfil = {
        id_modulo, id_perfil, id_licencia_tipo, id_colegio
      }

      try {
        let response = await axios.post(
          "/sistema/perfilColegio/confSubModuloPerfil",
          configuracionesPerfil
        );

        // console.log('perfiles de perfiles', response);

        // this.confSubModulo = response.data.subModulo;
        this.confSubModuloV_valida = response.data.confSubModuloV;
        this.confSubModuloA_valida = response.data.confSubModuloA;
        this.confSubModuloE_valida = response.data.confSubModuloE;
        this.confSubModuloD_valida = response.data.confSubModuloD;
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
      // }
    },

    /**
     ___________________________________________________________________________________
    |           MÉTODO VALIDAR CHECKED DE PERMISO USUARIO CON PERMISO PERFIL          */
    validarPermisos(permisosArrayUsuario, permisosArrayPerfil, id_submodulo) {

      if (!permisosArrayPerfil.includes(id_submodulo)) {

        // const index = permisosArrayUsuario.indexOf(id_submodulo);

        // if (index !== -1) {
        //   permisosArrayUsuario.splice(index, 1); 
        // }

        // console.log({ permisosArrayUsuario });
        return true;
      } else {
        return false;
      }
    },
    /**
     ______________________________________________________________________
    |           MÉTODO OBTENER LOS PERMISOS SUBMODULOS USUARIOS          */
    async getAllSubModUsuario(id_usuario, id_licencia_tipo, id_colegio) {
      try {
        this.configuracion.id_modulo = "";
        this.configuracion.id_usuario = id_usuario;
        this.configuracion.id_colegio = id_colegio;
        this.configuracion.id_licencia_tipo = id_licencia_tipo;
        let response = await axios.post(
          "/sistema/usuario/confSubModuloUsuario",
          this.configuracion
        );

        this.confSubModulo = response.data.subModulo;
        this.confSubModuloV = response.data.confSubModuloV;
        this.confSubModuloA = response.data.confSubModuloA;
        this.confSubModuloE = response.data.confSubModuloE;
        this.confSubModuloD = response.data.confSubModuloD;

        let minLength = Math.min(this.confSubModuloV.length, this.confSubModuloA.length, this.confSubModuloE.length, this.confSubModuloD.length);

        if (minLength === this.confSubModuloV.length.length) {
          this.confSubModuloAll = this.confSubModuloV;
        } else if (minLength === this.confSubModuloA.length.length) {
          this.confSubModuloAll = this.confSubModuloA;
        } else if (minLength === this.confSubModuloE.length.length) {
          this.confSubModuloAll = this.confSubModuloE;
        } else {
          this.confSubModuloAll = this.confSubModuloD;
        }

        this.organizarDatos();
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
    /**
     _____________________________________________________________
    |          MÉTODO CARGAR SUBMODULOS POR ID Y TODOS          */
    async onChangeSubModulo() {
      if (
        this.configuracion.id_perfil != null &&
        this.configuracion.id_modulo != null
      ) {
        try {
          let response = await axios.post(
            "/sistema/perfilColegio/confSubModuloPerfil",
            this.configuracion
          );
          this.confSubModulo = response.data.subModulo;
          this.confSubModuloV = response.data.confSubModuloV;
          this.confSubModuloA = response.data.confSubModuloA;
          this.confSubModuloE = response.data.confSubModuloE;
          this.confSubModuloD = response.data.confSubModuloD;
        } catch (e) {
          (console.error || console.log).call(console, e.stack || e);
        }
      }
    },
    /**
     __________________________________________________
    |          MÉTODO CARGAR LICENCIA TIPO           */
    async cargarLicenciaTipo(perfil) {
      try {
        let params = `/sistema/usuario/perfilLicenciaTipo/colegio/${this.datoLogin.id_colegio}/perfil/${perfil}/usuario/${this.datoLogin.id}`;
        let response = await axios.get(params);
        this.LicenciaTipo = response.data;
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /**
     ____________________________________________
    |          MÉTODO CARGAR LICENCIA          */
    async cargarLicencia() {
      //this.setEnviarMens({tipo:"W", mensaje: `Cargar Lincencia`, tiempo:null})
      try {
        let params = `/sistema/usuario/licenciaDisponibles/licenciaTipo/${this.datos.id_licencia_tipo}/colegio/${this.datoLogin.id_colegio}/usuario/${this.datoLogin.id}`;
        let response = await axios.get(params);
        this.Licencia = response.data;
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /**
     _____________________________________________
    |          MÉTODO CAMBIAR DOCUMENTO         */
    async changeDocument(id) {
      if (id == 4) {
        this.rul.maxDocument = (v) => (v || "").length <= 11 || "Máximo 11 caracteres";
      }
      if (id == 1) {
        this.rul.maxDocument = (v) => (v || "").length <= 8 || "Máximo 8 caracteres";
      }
      if (id == 2) {
        this.rul.maxDocument = (v) => (v || "").length <= 15 || "Máximo 15 caracteres";
      }
    },
    /**
     __________________________________________
    |          MÉTODO SELECCIONAR PAIS       */
    async select_pais() {
      //console.log("persona:",this.persona)
      this.get_Nacionalidades(this.datos.id_pais_nacimiento);
    },
    /**
     __________________________________________________
    |          MÉTODO OBTENER NACIONALIDADES         */
    async get_Nacionalidades(id = "") {
      //this.persona.id_nacionalidad = 0;
      //console.log("id:", id);
      let url = "";
      if (id != "" && id != undefined) {
        url = `/mantenimiento/nacionalidades/pais/${id}/`;
      } else {
        url = "/mantenimiento/nacionalidades";
      }
      await axios.get(url).then((response) => {
        this.Nacionalidades = response.data;
      });
    },
    /**
     ____________________________________
    |          MÉTODO ADD ITEMS        */
    async addItem() {
      this.$refs.formDatosValidar.resetValidation();
      this.dialogValidar = true;
      this.documento_validar = null;
    },
    /**
     _________________________________________________________________________
    |          MÉTODO ABRIR MODAL CONFIGURACION DE PERMISOS USUARIO         */
    async configPermisos(item) {

      this.confSubModuloAll = [],


        this.dialogPermisos = true;

      this.variablesEntorno.id = item.id;
      this.variablesEntorno.nameuser = item.apellido_nombre;
      this.variablesEntorno.perfildesc = item.descripcion_perfil;
      // this.getModuloTLicencia(item.id_colegio, item.id_licencia_tipo);
      this.getAllSubModUsuario(item.id, item.id_licencia_tipo, item.id_colegio);

      this.cargarAllSubModuloPerf('', item.id_perfil, item.id_licencia_tipo, item.id_colegio);

    },
    /**
     _____________________________________________________
    |          MÉTODO OBTENER DATOS PARA EDITAR         */
    async editItem(item) {
      this.disableUserInputs = true;
      this.bloquearInput = false;
      this.dialog = true;
      this.evento = "editar";
      this.formTitle = "Editar usuario";
      this.limpiarForm();

      await this.getQuery();
      this.datos = Object.assign({}, item);
      this.resetValidation();

      this.datos.password_usuario = "";
      // bloquear los campos para usuario master del colegio
      if (item.master_colegio == 1) {
        this.habilitarUsMaster = true;
      }

      this.cargarLicenciaTipo(item.id_perfil)
      this.get_Nacionalidades(item.id_pais_nacimiento)
      await this.loadUbicacion1(item.id_pais)
      await this.loadUbicacion2(item.id_ubicacion1)
      await this.loadUbicacion3(item.id_ubicacion2)
    },
    /**
     ___________________________________________
    |          MÉTODO VERIFICAR CHECKBOX      */
    algunosPermisosSeleccionados(idsubomdulo) {

      return ((this.confSubModuloV.includes(idsubomdulo) ||
        this.confSubModuloA.includes(idsubomdulo) ||
        this.confSubModuloE.includes(idsubomdulo) ||
        this.confSubModuloD.includes(idsubomdulo)) && !this.confSubModuloAll.includes(idsubomdulo));
    },
    /**
     ____________________________________________________________________
    |          MÉTODO SELECCIONAR TODOS LOS CHECKBOX (PERMISOS)        */
    toggleTodosSeleccionados(itemID) {

      if (!this.confSubModuloV.includes(itemID) &&
        !this.confSubModuloA.includes(itemID) &&
        !this.confSubModuloE.includes(itemID) &&
        !this.confSubModuloD.includes(itemID)) {
        this.confSubModuloV.push(itemID);
        this.confSubModuloA.push(itemID);
        this.confSubModuloE.push(itemID);
        this.confSubModuloD.push(itemID);
      } else if (!this.confSubModuloV.includes(itemID) ||
        !this.confSubModuloA.includes(itemID) ||
        !this.confSubModuloE.includes(itemID) ||
        !this.confSubModuloD.includes(itemID)) {
        const index1 = this.confSubModuloV.indexOf(itemID);
        if (index1 > -1) this.confSubModuloV.splice(index1, 1);

        const index2 = this.confSubModuloA.indexOf(itemID);
        if (index2 > -1) this.confSubModuloA.splice(index2, 1);

        const index3 = this.confSubModuloE.indexOf(itemID);
        if (index3 > -1) this.confSubModuloE.splice(index3, 1);

        const index4 = this.confSubModuloD.indexOf(itemID);
        if (index4 > -1) this.confSubModuloD.splice(index4, 1);

        this.confSubModuloV.push(itemID);
        this.confSubModuloA.push(itemID);
        this.confSubModuloE.push(itemID);
        this.confSubModuloD.push(itemID);

      } else {
        const index1 = this.confSubModuloV.indexOf(itemID);
        if (index1 > -1) this.confSubModuloV.splice(index1, 1);

        const index2 = this.confSubModuloA.indexOf(itemID);
        if (index2 > -1) this.confSubModuloA.splice(index2, 1);

        const index3 = this.confSubModuloE.indexOf(itemID);
        if (index3 > -1) this.confSubModuloE.splice(index3, 1);

        const index4 = this.confSubModuloD.indexOf(itemID);
        if (index4 > -1) this.confSubModuloD.splice(index4, 1);
      }

    },
    /**
     ____________________________________________________________________
    |          MÉTODO SELECCIONAR UN CHECKBOX (UN SOLO PERMISO)        */
    seleccionarPermiso(itemID) {

      if (
        this.confSubModuloV.includes(itemID) &&
        this.confSubModuloA.includes(itemID) &&
        this.confSubModuloE.includes(itemID) &&
        this.confSubModuloD.includes(itemID)
      ) {
        this.confSubModuloAll.push(itemID);
      } else {
        // this.algunosPermisosSeleccionados(itemID);
        const index = this.confSubModuloAll.indexOf(itemID);
        if (index > -1) this.confSubModuloAll.splice(index, 1);
      }
    },
    /**
     ________________________________________________________
    |          MÉTODO GUARDAR PERMISOS DE USUARIO          */
    async savePermisosUsuario() {

      try {

        let params = {
          id_usuario_new: this.variablesEntorno.id,
          configuracion: this.configuracion,
          subModulo: this.confSubModulo,
          confSubModuloV: this.confSubModuloV,
          confSubModuloA: this.confSubModuloA,
          confSubModuloE: this.confSubModuloE,
          confSubModuloD: this.confSubModuloD,
          id_usuario: this.datoLogin.id,
        };

        const res = await axios.post(
          "/sistema/perfilColegio/saveConfigUsuario",
          params
        );
        this.setEnviarMens({
          tipo: 'S',
          mensaje: res.message,
          tiempo: "null",
        });
        this.dialogPermisos = false;
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
    /**
     ___________________________________________
    |          MÉTODO GUARDAR DATOS           */
    async saveItem() {
      if (this.$refs.formUsuarios.validate()) {
        try {
          //let params = this.datos
          this.datos.id_usuario = this.datoLogin.id;
          this.datos.id_nacionalidad = this.datos.id_pais_nacimiento;
          this.datos.evento = this.evento;
          console.log("DATOS:", this.datos);
          let id_persona_edit = this.datos.id_persona;
          if (this.evento == "agregar") {
            let arrColegio = this.Colegio.filter(
              (element) => element.id == this.datoLogin.id_colegio
            );
            // alert(JSON.stringify(arrColegio))
            this.datos.id_pais = arrColegio[0].id_pais;
            this.datos.id_usuario = this.datoLogin.id;
            this.datos.id_colegio = this.datoLogin.id_colegio;

            //console.log(` VALOR A FILTAR: ${JSON.stringify(this.datos.id_colegio)} DATOS PAIS  ${JSON.stringify(this.datos.id_pais)}, ID PAIS  ${JSON.stringify(arrColegio[0].id_pais)}`);
            let { data } = await axios.post("/sistema/usuario/", this.datos);
            if (data.success) {

              this.setEnviarMens({
                tipo: data.messageT,
                mensaje: data.message,
                tiempo: "null",
              });
            } else {
              this.setEnviarMens({
                tipo: data.messageT,
                mensaje: data.message,
                tiempo: "null",
              });
            }
          }

          if (this.evento == "editar") {
            console.log("edit_user", this.datos);
            let { data } = await axios.put(
              "/sistema/usuario/" + this.datos.id,
              this.datos
            );
            console.log("entrando en data")
            if (data.success) {
              console.log("entre en data.success")
              this.setEnviarMens({
                tipo: data.messageT,
                mensaje: data.message,
                tiempo: "null",
              });
            } else {
              this.setEnviarMens({
                tipo: data.messageT,
                mensaje: data.message,
                tiempo: "null",
              });
            }
          }

          // si existe una imagen preview y la imagen a enviar al servidor, Guarda el avatar
          // SAVE AVATAR
          console.log(`Guardar Imagenes Avatar`)
          // console.log(` Variables previewImgAvatar: ${this.previewImgAvatar}, imageSaveAvatar: ${this.imageSaveAvatar}`);

          if (this.imageSaveAvatar) {
            this.saveAvatar(id_persona_edit);
          } else {
            this.dialog = false;
            this.loadMain();
            this.limpiarForm();

          }
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe de ingresar todos los campos Requerido`,
          tiempo: null,
        });
      }
    },
    /**
     __________________________________________
    |          MÉTODO GUARDAR AVATAR         */
    saveAvatar(id_persona_edit) {
      let formData = new FormData();
      formData.append("subirArchivo", this.imageSaveAvatar);
      formData.append("id_colegio", this.datoLogin.id_colegio);
      formData.append("id_usuario", this.datoLogin.id);
      formData.append("id_persona", id_persona_edit);

      axios
        .post("archivo/avatarPersona", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          this.dialog = false;
          this.loadMain();
          this.limpiarForm();
        })
        .catch(function (e) {
          console.log(e);
          this.setEnviarMens({
            tipo: "E",
            mensaje: `Error en Subir Imagen`,
            tiempo: null,
          });
        });
    },
    /**
     _____________________________________________________________
    |          MÉTODO CONTENEDOR DEL AVATAR DEL COLEGIO         */
    pickAvatar() {
      // activar imput tipo file
      this.$refs.imageAvatar.click();
    },
    /**
     ___________________________________________________
    |          MÉTODO CARGAR AVATAR ARCHIVO           */
    onFileAvatar(e) {
      const files = e.target.files || e.dataTransfer.files;

      console.log("EVENTO", e);
      if (!files.length) return;
      // crea imagen temporar para visualizar
      this.createImageAvatar(files[0]);

      if (files[0] !== undefined) {
        this.imageSaveAvatar = files[0]; // this is an image file that can be sent to server...
      }
    },
    /**
     __________________________________________________
    |          MÉTODO CREAR AVATAR TEMPORAL          */
    createImageAvatar(file) {

      var reader = new FileReader();
      reader.onload = (e) => {
        this.previewImgAvatar = e.target.result;
      };

      reader.readAsDataURL(file);

    },
    /**
     _____________________________________________
    |          MÉTODO CONFIRMAR BORRAR          */
    deleteConfirm(items) {
      this.dialog_delete = true;
      this.id_delete = items.id;
      this.desc_delete = `${items.nombre_persona} ${items.ape1_persona} ${items.ape2_persona}`;
    },
    /**
     _____________________________________________
    |          MÉTODO BORRAR REGISTROS          */
    async deleteItem() {
      this.dialog_delete = false;
      try {
        let resp = await axios.delete("/sistema/usuario/" + this.id_delete);
        this.loadMain();
        this.dialog = false;
        this.setEnviarMens({
          tipo: resp.data.messageT,
          mensaje: resp.data.message,
          tiempo: null,
        });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /**
     _____________________________________________________________
    |          MÉTODO CARGAR METODOS Y DATOS INICIALES          */
    async getQuery() {
      try {
        let response = await axios.get(
          "/sistema/usuario/getQuery/" + this.datoLogin.id_colegio
        );
        //console.log(`Datos Query : ${JSON.stringify(response.data.pais)} `)

        this.Colegio = response.data.colegio;
        this.TipoDocumentos = response.data.tipoDocumento;
        this.Perfil = response.data.perfil;
        this.Paises = response.data.pais;
        this.Ubicacion1 = response.data.ubicacion1;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /**
     __________________________________________________
    |          MÉTODO OBTENER DEPARTAMENTOS          */
    async loadUbicacion1(id) {
      //console.log(` load Ubicacion1 ${id}`)
      try {
        let response = await axios.get("/mantenimiento/ubicacion1/" + id);
        this.Ubicacion1 = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /**
     _______________________________________________
    |          MÉTODO OBTENER PROVINCIAS          */
    async loadUbicacion2(id) {
      //console.log(` load Ubicacion2 ${id}`)
      try {
        let response = await axios.get("/mantenimiento/ubicacion2/" + id + "");
        this.Ubicacion2 = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /**
     ______________________________________________
    |          MÉTODO OBTENER DISTRITOS          */
    async loadUbicacion3(id) {
      //console.log(` load Ubicacion3 ${id}`)
      try {
        let response = await axios.get("/mantenimiento/ubicacion3/" + id + "");
        this.Ubicacion3 = response.data;
        //this.datos.id_ubicacion3 = null
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /**
     ______________________________________________
    |          MÉTODO VALIDAR DOCUMENTO          */
    async validarDoc() {
      if (this.$refs.formDatosValidar.validate()) {
        this.limpiarForm();
        await this.getQuery();

        try {
          const response = await axios.get(
            "/administrativo/personal/validarDocumento/Documento/" +
            this.documento_validar +
            "/colegio/" +
            this.datoLogin.id_colegio +
            "/usuario/" +
            this.datoLogin.id
          );

          this.respuestaValidDoc = response.data;

          if (this.respuestaValidDoc != null) {
            this.setEnviarMens({
              tipo: "S",
              mensaje: "Existe información asociada a éste Número de Documento",
              tiempo: null,
            });
            this.bloquearInput = true;
            this.datos = this.respuestaValidDoc;
            this.datos.master_ck1 = 0;
            this.datos.estado_usuario = 0;
            this.datos.usu_usuario =
              this.respuestaValidDoc.numdoc_persona +
              -+this.respuestaValidDoc.id_colegio;

            //this.datos.id = 0
            this.datos.id_persona = this.respuestaValidDoc.id;
            // console.log("data:",response)
            await this.get_Nacionalidades(response.data.id_nacionalidad)
            this.datos.id_nacionalidad = response.data.id_nacionalidad
            this.datos.id_usuario = this.datoLogin.id;



            (this.datos.id_licencia = 0),
              await this.loadUbicacion1(this.respuestaValidDoc.id_pais);
            await this.loadUbicacion2(this.respuestaValidDoc.id_ubicacion1);
            await this.loadUbicacion3(this.respuestaValidDoc.id_ubicacion2);
          } else {
            this.setEnviarMens({
              tipo: "W",
              mensaje:
                "No existe información asociada a éste ''número de documento''",
              tiempo: null,
            });
            this.bloquearInput = false;
            this.datos.numdoc_persona = this.documento_validar;
            this.datos.usu_usuario =
              this.documento_validar + -+this.datoLogin.id_colegio;
          }

          this.dialogValidar = false;

          this.dialog = true;
          this.evento = "agregar";
          this.formTitle = "Crear Usuario";

        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
          console.log(error);
        }
      }
    },
    /**
     _______________________________________________
    |          MÉTODO LIMPIAR FORMULARIO          */
    async limpiarForm() {



      let dataForm = {
        id: 0,
        id_persona: 0,
        id_colegio: 0,
        id_tipo_documento: 0,
        id_tipo_usuario: null,
        id_perfil: 0,
        numdoc_persona: "",
        ape1_persona: null,
        ape2_persona: null,
        nombre_persona: null,
        sexo_persona: "",
        fecnac_persona: "",
        id_nacionalidad: 0,
        id_pais_nacimiento: 0,
        id_pais: 0,
        id_ubicacion1: 0,
        id_ubicacion2: 0,
        id_ubicacion3: 0,
        telf_persona: "",
        correo_persona: "",
        direc_persona: "",
        avatar_persona: "",
        ruta_avatar_persona: null,
        estado_persona: 0,
        id_usuario: null,
        id_licencia: 0,
        usu_usuario: "",
        password_usuario: "",
        estado_usuario: 1,
        id_licencia_tipo: null,
      };

      // no borrar data para hacer prueba
      /*
                let dataFormPrueba = {id:0, id_persona:0, id_colegio:6, id_tipo_documento:1, master_ck1: 1,
                            id_tipo_usuario:1, id_perfil:5, numdoc_persona:'1212122',
                            ape1_persona:"aaaa", ape2_persona:"bbbb", nombre_persona:"alberto",
                            sexo_persona:'M', fecnac_persona:'1998-01-15', id_nacionalidad:52,
                            id_pais_nacimiento:52, id_pais : 0, id_ubicacion1:0,
                            id_ubicacion2:0, id_ubicacion3:0, telf_persona:'',
                            correo_persona:'xxx@ww.xom', direc_persona:'xxx', avatar_persona:'',
                            ruta_avatar_persona: null, estado_persona:0, id_usuario:this.datoLogin.id,
                            id_licencia : 0, usu_usuario:'xxxxxx', password_usuario:12345699, estado_usuario:0}
                */

      this.previewImgAvatar = "";
      this.imageSaveAvatar = ""

      this.habilitarUsMaster = false;
      this.datos = dataForm;

      this.resetValidation();
    },
    /**
     _______________________________________________
    |          MÉTODO REFRESH FORMULARIO          */
    resetValidation() {
      this.$refs.formUsuarios.resetValidation();
    },
    /**
     __________________________________________________
    |          MÉTODO VALIDAR FORMATO FECHA          */
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    /**
     _________________________________________
    |          MÉTODO VALIDAR DATE          */
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    /**
     _____________________________________________________
    |          MÉTODO RESTRICCION SOLO NUMEROS          */
    restrictCharsNumeros: function ($event) {
      if (
        $event.charCode === 0 ||
        /\d/.test(String.fromCharCode($event.charCode))
      ) {
        return true;
      } else {
        $event.preventDefault();
      }
    },
    /**
     ____________________________________________________
    |          MÉTODO RESTRICCION SOLO LETRAS          */
    restrictCharsLetras: function ($event) {
      if (
        $event.charCode === 0 ||
        /"^[a-zA-Z ]+$" /.test(String.fromCharCode($event.charCode))
      ) {
        return true;
      } else {
        $event.preventDefault();
      }
    },
  },
};
</script>
<style scoped>
.fondo_add_img {
  cursor: pointer;
  cursor: hand;
  max-width: 100%;
  /* Esto asegura que la imagen no sea más ancha que su contenedor */
  max-height: 100%;
  /* Esto asegura que la imagen no sea más alta que su contenedor */
  height: auto;
  /* Esto mantiene la proporción original de la imagen */
  border: 0px solid white;
}

.avatar_fondo_add_img {
  border-radius: 10%;
  /* border: solid 1px rgb(197, 197, 197);
  border-style: dashed; */
}

.avatar_fondo_add_img:hover {
  border: solid 1px rgb(197, 197, 197);
  border-style: dashed;
}
</style>